var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.appLoading,"color":"white"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"80"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }